export default __webpack_public_path__ + "static/media/upload-circle.84bb6df6.svg";